export function getNotificationPermission() {
  if (typeof Notification === 'undefined') return 'unsupported';
  return Notification.permission; // 'default' | 'granted' | 'denied'
}

export async function requestNotificationPermission() {
  if (typeof Notification === 'undefined') return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  try {
    const result = await Notification.requestPermission();
    return result;
  } catch {
    return 'denied';
  }
}

export function sendDealNotification(dealTitle, shopName) {
  if (typeof Notification === 'undefined') return false;
  if (Notification.permission !== 'granted') return false;
  try {
    new Notification('WalkIn Deal! 🎉', {
      body: `${shopName}: ${dealTitle}`,
      icon: '/logo192.png',
    });
    return true;
  } catch {
    return false;
  }
}

export function sendCustomNotification(title, body) {
  if (typeof Notification === 'undefined') return false;
  if (Notification.permission !== 'granted') return false;
  try {
    new Notification(title, { body, icon: '/logo192.png' });
    return true;
  } catch {
    return false;
  }
}

export function scheduleNotification(title, body, delayMs) {
  if (typeof Notification === 'undefined') return null;
  return setTimeout(() => sendCustomNotification(title, body), delayMs);
}
